import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Lock, User, Shield } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Auto-redirect if already logged in
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      navigate("/webo0os/dashboard");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.error("Ingresa usuario y contraseña");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { username, password });
      const { token, username: user } = response.data;
      
      localStorage.setItem("adminToken", token);
      localStorage.setItem("adminUsername", user);
      
      toast.success("Acceso concedido");
      navigate("/webo0os/dashboard");
    } catch (error) {
      toast.error("Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg min-h-screen flex items-center justify-center p-4">
      <div className="login-overlay absolute inset-0" />
      
      <div 
        className="relative z-10 w-full max-w-md animate-fade-in"
        data-testid="admin-login-container"
      >
        {/* Logo/Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-md bg-card border border-border mb-6">
            <Shield className="w-10 h-10 text-primary" />
          </div>
          <h1 className="text-4xl font-bold uppercase tracking-widest text-foreground mb-2">
            CONTROL CENTER
          </h1>
          <p className="text-muted-foreground text-sm tracking-wide">
            ACCESO RESTRINGIDO - ADMIN
          </p>
        </div>

        {/* Login Form */}
        <div className="bg-card border border-border rounded-md p-8">
          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-2">
              <label className="text-xs uppercase tracking-wider text-muted-foreground font-medium">
                Usuario
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Ingresa tu usuario"
                  className="pl-10 h-12 bg-input border-border font-mono"
                  data-testid="admin-username-input"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-xs uppercase tracking-wider text-muted-foreground font-medium">
                Contraseña
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Ingresa tu contraseña"
                  className="pl-10 h-12 bg-input border-border font-mono"
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-primary hover:bg-primary/90 text-primary-foreground uppercase tracking-widest font-semibold btn-glow"
              data-testid="admin-login-button"
            >
              {loading ? "VERIFICANDO..." : "ACCEDER AL SISTEMA"}
            </Button>
          </form>
        </div>

        {/* Footer */}
        <p className="text-center text-muted-foreground text-xs mt-8 tracking-wide">
          ORBITAL FEEDBACK - PANEL DE CONTROL v1.0
        </p>
      </div>
    </div>
  );
}
